<div fxLayout="row">
  <div fxFlex="93">
    <h2>{{ data.Title | translate }}</h2>
  </div>
  <div fxFlex="7">
    <button mat-icon-button color="primary" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>

<div fxLayout="column" fxLayoutGap="10px">
  <form [formGroup]="formGroup">
    <app-legalization-file-type-selector
      [disabled]="data.IsCorrection"
      [selectedTypeId]="selectedLegalizationTypeId"
      (typeSelected)="onLegalizationTypeSelected($event)">
    </app-legalization-file-type-selector>

    @if (description.value) {
      <mat-form-field appearance="outline" fxFill class="readonly-field">
        <mat-label>{{ 'Legalization.DocumentDescription' | translate }}</mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          formControlName="description"
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="5"
          readonly
        ></textarea>
      </mat-form-field>
    }

  </form>
  <div fxFill>
    <fileUpload [maxFileCount]="maxFileCount$ | async" (onFilesChange)="onFilesChange($event)"></fileUpload>
  </div>

  <div class="header-wrapper"></div>

  <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="buttons-wrapper">
    <button mat-raised-button (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="createLegalizationDocument()" [disabled]="!isSendWorkerFileButtonEnabled()">
      {{ 'Save' | translate }}
    </button>
  </div>
</div>
